import Button from 'components/Button';
import { Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';

const ButtonBlock = ({ theme, padding, btn, waveBottom }) => {
  return (
    <Section padding={padding} theme={theme} waveBottom={waveBottom}>
      <Wrapper size="L" className="align-item-center">
        {
          btn.link ? <Button
          href={btn.link}
          text={btn.text}
          type={btn.type}
          size={btn.size}
          openNew={btn.openNew}
        /> : <Button
          href={btn.to}
          text={btn.text}
          type={btn.type}
          size={btn.size}
        />
        }
      </Wrapper>
    </Section>
  );  
}
ButtonBlock.propTypes = {
  theme: PropTypes.string,
  padding: PropTypes.string,
  btn: PropTypes.shape({
    to: PropTypes.string,
    link: PropTypes.string,
    text: PropTypes.string.isRequired,
    openNew: PropTypes.bool,
    type: PropTypes.string,
    size: PropTypes.string,
  }).isRequired,
  waveBottom: PropTypes.bool,
};

ButtonBlock.defaultProps ={
  padding: 'BottomL',
  theme: null,
  waveBottom: false
}

export default ButtonBlock;